import React, { HTMLAttributes, forwardRef } from 'react'
import tw from 'tailwind-styled-components'
import { ImageProps } from 'next/image'

import { ResponsiveImage } from './ResponsiveImage'

type Props = HTMLAttributes<HTMLButtonElement> & {
  img?: ImageProps['src']
  title: string
  active?: boolean
}
type ActiveProps = TransientProps<Props, 'active'>

const BaseButton = tw.button<ActiveProps>`
  flex
  items-center
  box-border
  px-5
  h-8
  md:h-11
  rounded
  transition
  duration-300
  border
  ${({ $active }) => ($active ? 'border-secondary-500' : 'border-gray-400')}
`

const Title = tw.p<ActiveProps>`
  flex
  ${({ $active }) => ($active ? 'text-primary-500' : 'text-gray-700')}
`

export const ActiveButton = forwardRef<HTMLButtonElement, Props>(
  ({ img, title, active, ...props }, ref) => {
    return (
      <BaseButton $active={active} ref={ref} {...props}>
        {img && (
          <div className='flex mr-3'>
            <ResponsiveImage src={img} sizes={[16, 20]} />
          </div>
        )}
        <Title $active={active}>{title}</Title>
      </BaseButton>
    )
  }
)
